export default __webpack_public_path__ + "static/media/Group757.957cf8eb.svg";